// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "message": {
      "column": {
        "default": null,
        "name": "message",
        "null": true,
        "type": "text"
      },
      "name": "message",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number": {
      "column": {
        "default": null,
        "name": "phone_number",
        "null": true,
        "type": "string"
      },
      "name": "phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "user_id": {
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      },
      "name": "user_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolContactRequest",
  "collectionKey": "school_contact_requests",
  "collectionName": "school_contact_requests",
  "i18nKey": "school_contact_request",
  "camelizedLower": "schoolContactRequest",
  "name": "SchoolContactRequest",
  "nameDasherized": "school-contact-request",
  "pluralName": "school_contact_requests",
  "ransackable_associations": [
    {
      "className": "SchoolContactRequest::Audit",
      "collectionName": "school_contact_request_audits",
      "foreignKey": "school_contact_request_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolContactRequestAudit",
      "through": null
    },
    {
      "className": "SchoolContactRequest::Audit",
      "collectionName": "school_contact_request_audits",
      "foreignKey": "school_contact_request_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolContactRequestAudit",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "message",
      "column": {
        "default": null,
        "name": "message",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "phone_number",
      "column": {
        "default": null,
        "name": "phone_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_id",
      "column": {
        "default": null,
        "name": "user_id",
        "null": false,
        "type": null
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "user",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "school_contact_request",
  "primaryKey": "id"
}

/** Frontend model for SchoolContactRequest. */
export default class SchoolContactRequest extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  message() {
    return this.readAttributeUnderscore("message")
  }

  /** @returns {boolean} */
  hasMessage() {
    const value = this.message()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  userId() {
    return this.readAttributeUnderscore("user_id")
  }

  /** @returns {boolean} */
  hasUserId() {
    const value = this.userId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static contactMySchool(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "contact_my_school",
        collectionName: "school_contact_requests",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("userId" in this)) throw new Error("Foreign key method wasn't defined: userId")

    const id = this.userId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
